import { apiClient } from './client';

export interface UserPreferences {
  analytics_logs?: {
    items_per_page?: number;
    live_update?: boolean;
    time_period?: '1h' | '24h' | '7d' | 'all';
  };
  analytics_overview?: {
    show_map?: boolean;
    time_period?: '24h' | '7d' | '30d';
  };
  hosts?: {
    items_per_page?: number;
  };
  [key: string]: unknown;
}

export interface UserPreferencesResponse {
  preferences: UserPreferences;
}

export interface UpdateUserPreferencesRequest {
  preferences: Partial<UserPreferences>;
}

export const preferencesApi = {
  get: async (): Promise<UserPreferencesResponse> => {
    const response = await apiClient.get('/auth/me/preferences');
    return response.data;
  },

  update: async (request: UpdateUserPreferencesRequest): Promise<UserPreferencesResponse> => {
    const response = await apiClient.patch('/auth/me/preferences', request);
    return response.data;
  },
};
